<template>
  <div class="wrapper">
    <div class="node_list">
        <el-tree 
        ref="treeNode"
        default-expand-all
        node-key="node_id"
        :highlight-current="true"
        :expand-on-click-node="false"
        :current-node-key="cur_key"
        :data="data" 
        :props="defaultProps" 
        @node-click="handleNodeClick" />
    </div>
    <div class="video_right">
        <div class="video_top">
            <div class="node_name">
                {{cur_node_name}}
            </div>
            <div class="tabs">
                <div v-if="!is_first_node" class="tab" :class="{act:show_type=='video'}" @click="changeShow('video')">视频</div>
                <div class="tab" :class="{act:show_type=='img' || is_first_node}" @click="changeShow('img')">图集</div>
            </div>
        </div>
        
        <div class="show_content">
            <div :class="['show_box',(show_type == 'video' && vid_list && vid_list.length>0) || (show_type == 'img' && img_list && img_list.length>0)?'':'empty']">
                <template v-if="show_type == 'video'">
                    <template v-if="vid_list && vid_list.length>0">
                        <video controlsList="nodownload" 
                        :src="vid_list && vid_list[show_ind]" 
                        controls
                        :poster="vid_list && vid_list[show_ind]+'?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,m_fast'"
                        preload="metadata"
                        
                        ></video>
                    </template>
                    <template v-else>
                        <div class="empty_content">
                            <div class="empty_img"></div>
                            <div class="empty_tit">暂无数据</div>
                        </div>
                    </template>
                </template>
                <template v-else-if="show_type == 'img'">
                    <template v-if="img_list && img_list.length>0">
                        <img :src="img_list && img_list[show_ind]" />
                    </template>
                    <template v-else>
                         <div class="empty_content">
                            <div class="empty_img"></div>
                            <div class="empty_tit">暂无数据</div>
                        </div>
                    </template>
                </template>
            </div>            
            <template v-if="(show_type == 'video' && vid_list && vid_list.length>0) || (show_type == 'img' && img_list && img_list.length>0)">
                <div class="btn prev" @click="cutInd"></div>
                <div class="btn next" @click="addInd"></div>
            </template>
           
        </div>
        <div class="cur_model_name">
            {{cur_model_name || query_model_name}}
            <span style="margin-left:10px;color:#666;font-size:16px;" v-if="show_type == 'video'?vid_list.length:img_list.length">( {{show_type == 'video'?((show_ind+1)+'/'+vid_list.length):((show_ind+1)+'/'+img_list.length)}} )</span>
            <!-- (<span style="color:#f00">{{cur_model_score || my_cur_node_score}}</span>) -->
        </div>
        <template v-if="rela_list && rela_list.length>0">
            <div class="relative_tit">相关{{is_first_node?'图集':'视频'}}</div>
            <div class="video_list">
                <div class="video_item" v-for="(item,ind) in rela_list" :key="ind" @click="changeVidList(item)">
                    <template v-if="is_first_node">
                        <div class="img_box">
                            <img :src="item['list'][0]['link_url']">
                        </div>
                    </template>
                    <template v-else>
                        <div class="video_poster">
                            <video controlsList="nodownload" 
                            :src="item['list'][0]['link_url']"
                            :poster="item['list'][0]['link_url']+'?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                            preload="none"
                            ></video>
                        </div>
                    </template>
                    <div class="video_tit">
                        {{item.model_name}}
                        <!-- （<span style="color:#f00">{{item.score}}分</span>） -->
                    </div>
                </div>
            </div>
        </template>
       
    </div>
  </div>
</template>

<script>
import { 
    ref,
} from "vue";
import{
    useRoute
} from "vue-router";
import {
    ElTree
} from "element-plus";
import {
    getNodeV2,
    getNodeDetailV2,
    getRelaVideoV2
} from "@/api";
export default {
    components:{
        ElTree,
    },
    setup(){
        const treeNode = ref(null);
        const data = ref(null);
        const defaultProps = {
            "label":"node_name",
            "children":"child",
            "isLeaf":"is_leaf",	
        }
        const is_first_node = ref(true);
        const cur_node_name = ref("");
        // 当前选中的节点key变化
        const cur_key_change = (key)=>{
            console.log(key)
            if(key[0] == 9 && key[1] == 9){
                is_first_node.value = true;
                img_list.value = [];
                 setTimeout(()=>{
                    cur_model_name.value = "";
                    cur_model_score.value = "";
                    cur_node_name.value = key[2];
                    treeNode.value.setCurrentKey(key[0]);
                    getNodeDetailV2Data(query_model_id.value,query_report_id.value,key[0]);
                    getRelaVideoV2Fn(query_report_id.value,key[1]);
                },100)
            }else{
                is_first_node.value = false;
                vid_list.value = [];
                setTimeout(()=>{
                    cur_model_name.value = "";
                    cur_model_score.value = "";
                    cur_node_name.value = key[2];
                    treeNode.value.setCurrentKey(key[0]);
                    getNodeDetailV2Data(query_model_id.value,query_report_id.value,key[0]);
                    getRelaVideoV2Fn(query_report_id.value,key[1]);
                },100)
            }

        }
        // 侧边菜单点击节点
        const handleNodeClick = (data)=>{
            console.log(data)
            let key = data.child && data.child.length>0?recursiveGetNode(data.child):[data.node_id,data.node_id,data.node_name];
            cur_key_change(key);
        }
        // 当前节点key值 node_id
        const cur_key = ref(0);
        // 递归获取树的第一个叶子节点
        const recursiveGetNode = (list)=>{
            if(list[0].child && list[0].child.length>0 && list[0].is_leaf == "0"){
                return recursiveGetNode(list[0].child);
            }else{
                return [list[0].node_id,list[0].node_id,list[0].node_name];
            }
        }
        const route = useRoute();
        // 获取节点树列表数据
        const getNodeV2Data = (
                model_id,
                report_id,
                // node_id = 4,
            )=>{
            getNodeV2({
                model_id,
                report_id,
                // node_id,
            }).then(res=>{
                if(res && res.code && res.code == 200){
                    let list = res.data;
                    data.value = list;
                    console.log(list)
                    if(!cur_key.value){
                        let key = recursiveGetNode(list);
                        cur_key_change(key)
                    }
                    
                }
            })
        }
        const img_list = ref([]);
        const vid_list = ref([]);
        const rela_list = ref([]);
        const my_cur_node_score = ref(0);
        
        // 获取节点的图片视频数据
        const getNodeDetailV2Data = (
            model_id,
            report_id, 
            node_id,
           )=>{
            getNodeDetailV2({
                model_id,
                report_id,
                node_id
            }).then(res=>{
                console.log(res.data);
                let item_value = res.data;
                let img_arr = [];
                let vid_arr = [];
                item_value.forEach(item => {
                    if(item.link_type == 1){
                        img_arr.push(item.link_url);
                    }else if(item.link_type == 2){
                        vid_arr.push(item.link_url);
                    }
                });
                show_type.value = is_first_node.value?'img':'video';
                img_list.value = img_arr;
                vid_list.value = vid_arr;
            })
        }
        // 获取节点相关视频列表
        const getRelaVideoV2Fn = (report_id,node_id)=>{
            getRelaVideoV2({
                report_id,
                node_id
            }).then(res=>{
                if(res && res.code && res.code ==200){
                    rela_list.value = res.data;
                }
            })
        }
        let {model_id,report_id,model_name} = route.query;
        const query_model_id = ref(model_id);
        const query_report_id = ref(report_id);
        const query_model_name = ref(model_name);

        const cur_model_name = ref("");
        const cur_model_score = ref("");
        getNodeV2Data(query_model_id.value,query_report_id.value,4);


        const show_type = ref("video");
        const show_ind = ref(0);
        const addInd = ()=>{
            let len = show_type.value == 'video'?vid_list.value.length:img_list.value.length;
            if(show_ind.value == len-1){
                show_ind.value = 0;
            }else{
                show_ind.value++;
            }
        }
        const cutInd = ()=>{
            let len = show_type.value == 'video' ? vid_list.value.length : img_list.value.length;
            if(show_ind.value == 0){
                show_ind.value = len-1;
            }else{
                show_ind.value--;
            }
        }
        const changeShow = (type)=>{
            cur_model_name.value = "";
            cur_model_score.value = "";
            show_type.value = type;
            show_ind.value = 0;
        }
        const changeVidList = (item)=>{
            cur_model_name.value = item.model_name;
            cur_model_score.value = item.score + "分";
            if(is_first_node.value){
                let img_arr = [];
                item.list.forEach(item => {
                    if(item.link_type == 1){
                        img_arr.push(item.link_url);
                    }
                })
                img_list.value = img_arr;
                show_type.value = "img";
            }else{
                let vid_arr = [];
                item.list.forEach(item => {
                    if(item.link_type == 2){
                        vid_arr.push(item.link_url);
                    }
                })
                vid_list.value = vid_arr;
                show_type.value = "video";
            }
           
            show_ind.value = 0;
        }
        return {
            treeNode,
            defaultProps,
            handleNodeClick,
            data,
            cur_key,
            show_type,
            show_ind,
            vid_list,
            img_list,
            addInd,
            cutInd,
            changeShow,
            rela_list,
            changeVidList,
            query_model_name,
            my_cur_node_score,
            cur_model_name,
            cur_model_score,
            cur_node_name,
            is_first_node
        }
    }
}
</script>

<style scoped lang="less">
.wrapper{
    display: flex;
    width: 1222px;
    height: calc(100vh - 180px);
    margin: 0 auto;
    .node_list{
        flex-shrink: 0;
        width: 200px;
        height: calc(100%);
        background: #fff;
        // border-right: 1px solid #EBEBEB;
        overflow-y: auto;
        position: sticky;
        top: 0;
        z-index: 20;
        .model_name{
            width: 100%;
            font-size: 20px;
            font-weight: bold;
            color: #474747;
            line-height: 35px;
            padding: 20px;
            background: #fff;
        }
        :deep(.el-tree){
            border-right: solid 1px #ddd;
        }
        :deep(.el-tree-node__label){
            font-size: 12px;
        }
         :deep(.el-tree-node.is-current){
            background: #EAEFF7;
            font-weight: bold;
            color: #474747;
            position: relative;
            &::after{
                content: "";
                width: 3px;
                height: 36px;
                background: #5390F1;
                position: absolute;
                right: 0;
                top: 0;
            }
        }
        :deep(.el-tree-node__content){
            font-size: 20px;
            height:36px;
            border-top: solid 1px #ddd;
            &:has(.is-current){
                font-weight: bold;
            }
            
        }
    }
    .video_right{
        // height: calc(100vh - 106px);
        width: 100%;
        overflow-y: scroll;
        background: #fff;
        padding:0 41px 40px 44px;
        .video_top{
            height: 75px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .node_name{
                font-size: 18px;
                font-weight: bold;
            }
            .tabs{
                display: flex;
                border: 1px solid #D1D1D1;
                border-radius: 4px;
                overflow: hidden;
                .tab{
                    cursor: pointer;
                    width: 100px;
                    height: 50px;
                    line-height: 50px;
                    font-size: 18px;
                    color: #474747;
                    background: #EDEDED;
                    text-align: center;
                    &.act{
                        background: #FFFFFF;
                        color: #5390F1;
                    }
                }
            }
        }
        
        .show_content{
            width: 100%;
            height: 595px;
            position: relative;
            .show_box{
                width: 100%;
                height: 100%;
                background: #000000;
                border-radius: 6px;
                overflow: hidden;
                &.empty{
                    background: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .empty_content{
                        .empty_img{
                            width: 181px;
                            height: 139px;
                            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/func_video_nodata.png) no-repeat center center;
                            background-size: 100%;
                        }
                    }
                    .empty_tit{
                        font-size: 16px;
                        color:#7B7B7B;
                        text-align: center;
                    }
                }
                video,img{
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            .btn{
                width: 40px;
                height: 40px;
                position: absolute;
                top: 50%;
                cursor: pointer;
                &.prev{
                    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/btn_prev_change_13.png) no-repeat center center;
                    background-size: 100%;
                    left: 0;
                }
                &.next{
                    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/btn_next_change_13.png) no-repeat center center;
                    background-size: 100%;
                    right: 0;
                }
                transform: translateY(-50%);
            }
        }
    }
}
.cur_model_name{
    font-size: 20px;
    line-height: 40px;
    margin-top: 10px;
    .cur_model_score{
        color: #f00;
    }
}
.relative_tit{
    margin-top: 43px;
    height: 24px;
    font-size: 18px;
    font-weight: bold;
    color: #474747;
    line-height: 24px;
}
.video_list{
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    &::after {
        content: '';
        flex: auto;
    }
    .video_item{
        cursor: pointer;
        width: 225px;
        margin-right: 10px;
        &:nth-child(4n){
            margin-right: 0;
        }
        .img_box{
            width: 225px;
            height: 133px;
            border-radius: 6px;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .video_poster{
            width: 225px;
            height: 133px;
            background: #D8D8D8;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
            video,img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            &::after{
                content:"";
                width: 100%;
                height: 100%;
                background:rgba(0, 0, 0, .4) url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/relative_video_item_bf.png) no-repeat center center;
                background-size: 40px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
        }
        .video_tit{
            display: flex;
            align-items: center;
            height: 55px;
            font-size: 14px;
            color: #474747;
            line-height: 19px;
        }
    }
    
}

</style>